import MarkdownLegalDocument from 'components/MarkdownLegalDocument';

export default () => {
  return <MarkdownLegalDocument content={'privacyPolicyInMarkdown'} />;
};
